import {
  JobPhaseReceivableDto,
  JobPhaseReceivableUpdatableInterface,
} from '@vatos-pas/common';
import { axiosInstance } from 'services/http';
import { extractErrorMessage } from 'utils';

type ReceivableBooleanFields = Pick<
  JobPhaseReceivableUpdatableInterface,
  'supplyProIntegrated' | 'billed'
>;

type ReceivableInvoiceFields = Pick<
  JobPhaseReceivableUpdatableInterface,
  'invoicePOAmount' | 'internalInvoiceNumber'
>;

export type ReceivableChanges = Partial<
  ReceivableBooleanFields & ReceivableInvoiceFields
>;

export type SaveArgs = {
  jobPhaseId: string;
  changes: ReceivableChanges;
};

/**
 * One idempotent PUT job-phase-receivable/by-job-phase/:jobPhaseId with the
 * changed keys only. The API creates the row when the phase has none and
 * updates it otherwise, so the cell no longer decides between POST and PATCH,
 * needs the row id up front, or races a sibling cell on the create.
 */
export async function saveReceivable({
  jobPhaseId,
  changes,
}: SaveArgs): Promise<JobPhaseReceivableDto> {
  try {
    const { data } = await axiosInstance.put<JobPhaseReceivableDto>(
      `job-phase-receivable/by-job-phase/${jobPhaseId}`,
      changes,
    );
    return data;
  } catch (error: any) {
    throw new Error(
      extractErrorMessage(error, 'Failed to save the receivable'),
    );
  }
}

export const useReceivablePersistence = (): {
  save: (args: SaveArgs) => Promise<JobPhaseReceivableDto>;
} => ({ save: saveReceivable });
